import Component from '../app/component'
import { animate, stagger } from 'motion'

export default class TopComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      subIndex: -1,
      linkLeft: -1,
      subMenuLeft: -1,
      isTop: true,
      scrollDirection: null,
      topHeight: null
    }
  }

  init () {
    this.navLinksHandle()
    this.scrollHandle()

    if (this.refs.mobileNav) {
      this.refs.mobileNav.addEventListener('pointerdown', () => document.eventEmit('mobilemenu.toggle'))
    }
  }

  scrollHandle() {
    let timeout
    let y = window.scrollY

    const scrollTest = function() {
      const currentY = window.scrollY
      if (currentY <= 0) {
        if (!this.data.isTop) {
          this.data.isTop = true
        }
      }
      else {
        if (this.data.isTop) {
          this.data.isTop = false
        }
      }
      
      if (currentY > y) {
        this.data.scrollDirection = 'down'
      }
      else if (currentY < y) {
        this.data.scrollDirection = 'up'
      }
      else {
        this.data.scrollDirection = null
      }

      y = currentY
    }.bind(this)

    // immediate call
    scrollTest()

    const scrollListener = function() {
      if (timeout) {
        return
      }
      else {
        // immediate call
        if (timeout === undefined) {
          scrollTest()
        }
        timeout = setTimeout(() => {
          timeout = null
          scrollTest()
        }, 50)
      }
    }.bind(this)

    window.addEventListener('scroll', scrollListener)
  }

  navLinksHandle() {
    if (this.refs?.navLinks?.length) {
      this.refs.navLinks.forEach(el => {
        el.addEventListener('mouseover', () => {
          clearTimeout(this.outDelay)
          if(el.dataset?.sub === '1') {
            this.toggleSub(parseInt(el.dataset.index))
          }
          else {
            this.toggleSub(-1)
          }
        })
        
        el.addEventListener('mouseleave', () => {
          this.toggleOutDelay()
        })
      })
    }

    if (this.refs.menu) {
      this.refs.menu.addEventListener('mouseenter', () => {
        clearTimeout(this.outDelay)
      })

      this.refs.menu.addEventListener('mouseleave', () => {
        this.toggleOutDelay()
      })
    }
  }

  watchIsTop(value) {
    if (value) {
      this.el.classList.add(this.el.dataset.topClass)
    }
    else {
      this.el.classList.remove(this.el.dataset.topClass)
    }
  }

  watchScrollDirection(value) {
    if (this.data.isTop) {
      this.el.classList.remove(this.el.dataset.scrollUpClass)
      this.el.classList.remove(this.el.dataset.scrollDownClass)
      return
    }
    if (value === 'down') {
      this.data.subIndex = -1
      this.el.classList.add(this.el.dataset.scrollDownClass)
      this.el.classList.remove(this.el.dataset.scrollUpClass)
    }
    if (value === 'up') {
      this.data.subIndex = -1
      this.el.classList.add(this.el.dataset.scrollUpClass)
      this.el.classList.remove(this.el.dataset.scrollDownClass)
    }
    // new top height
    setTimeout(() => {
      this.data.topHeight = this.el.offsetHeight - 1
    }, 350)
  }

  watchTopHeight(value) {
    if (typeof value === 'number') {
      this.refs.menu.style.top = `${this.el.offsetHeight}px`
    }
  }

  toggleOutDelay() {
    const currentSubIndex = this.data.subIndex
    // close after 500ms
    this.outDelay = setTimeout(() => {
      if (this.data.subIndex === currentSubIndex) {
        this.toggleSub(-1)
      }
    }, 500)
  }

  toggleSub(index) {
    console.log(index)
    if (index < 0) {
      this.refs.menu.classList.remove(this.refs.menu.dataset.activeClass)
      setTimeout(() => {
        this.data.subIndex = -1  
      }, 200)
    }
    else if (this.data.subIndex === index) {
      this.tweenSubOut().then(() => {
        this.data.subIndex = -1
        this.refs.menu.classList.remove(this.refs.menu.dataset.activeClass)
      })
    }
    else {
      const rem = window.innerWidth * 0.01

      Promise.resolve()
        .then(() => {
          if (this.data.subIndex < 0) {
            return
          }
          return this.tweenSubOut()
        })
        .then(() => {
          this.data.subIndex = index
          this.refs.menu.classList.add(this.refs.menu.dataset.activeClass)

          const navLinkEl = this.refs.navLinks.filter(el => parseInt(el.dataset.index) === this.data.subIndex)[0]
          this.data.linkLeft = navLinkEl.getBoundingClientRect().left + rem
        })
        .then(() => this.tweenSubIn())
    }
  }

  watchSubIndex(value) {
    if (this.refs?.subs?.length) {
      this.refs.subs.forEach((el) => {
        if (el.classList.contains(`top-menu-sub--${value}`)) {
          el.classList.add(el.dataset.activeClass)
        }
        else {
          el.classList.remove(el.dataset.activeClass)
        }
      })
    }
  }

  watchLinkLeft(value) {
    const contentEl = this.el.querySelector(this.refs.menu.dataset.contentSelector)
    if (contentEl && value) {
      this.data.subMenuLeft = value - contentEl.getBoundingClientRect().left
    }
  }

  watchSubMenuLeft(value) {
    const contentEl = this.el.querySelector(this.refs.menu.dataset.contentSelector)
    if (contentEl) {
      contentEl.style.paddingLeft = `${value}px`
    }
  }

  tweenSubIn() {
    const subEl = this.refs.subs.filter(el => el.classList.contains(`top-menu-sub--${this.data.subIndex}`))[0]
    if (subEl) {
      return animate(
        subEl.querySelectorAll(':scope > *'),
        {
          transform: ['translateY(2rem)', 'translateY(0)'],
          opacity: [0, 1]
        },
        {
          duration: 0.8,
          easing: [.66, 0, .03, .99],
          delay: stagger(0.1)
        }
      ).finished
    }
  }

  tweenSubOut() {
    const subEl = this.refs.subs[this.data.subIndex] 
    if (subEl) {
      return animate(
        subEl.querySelectorAll(':scope > *'),
        {
          transform: [null, 'translateY(2rem)'],
          opacity: [null, 0]
        },
        {
          duration: 0.2,
          easing: [.66, 0, .03, .99],
          delay: stagger(0.1)
        }
      ).finished
    }   
  }
}
